import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'connected-react-router/immutable';

import {loadUserCampaigns} from '../../actions/userCampaign';
import {loadReports} from '../../actions/reports';
import {getUserId} from '../../reducers/user';
import {getReports, getReportsloadingState} from '../../reducers/reports';
import {
  getUserCampaignId,
  getNoReportText,
  getUserCampaignLoadingState,
  getReportStatus,
} from '../../reducers/userCampaign';

import ReportsList from '../../components/ReportsList';
import LoadingSpinner from '../../components/LoadingSpinner';

class ReportsPage extends Component {
  componentDidMount() {
    const {campaignId, loadUserCampaigns, loadReports} = this.props;

    if (!campaignId) {
      loadUserCampaigns();
      return;
    }

    //LOAD REPORTS THE OLD WAY
    loadReports(campaignId);
  }

  componentDidUpdate(prevProps) {
    const {campaignId, loadReports} = this.props;

    if (prevProps.campaignId !== campaignId) {
      loadReports(campaignId);
    }
  }

  render() {
    const {
      canDownloadReport,
      campaignId,
      noReportText,
      userCampaignLoadingState,
      userId,
      jasperReports,
      jasperReportsLoadingState,
    } = this.props;

    if (
      userCampaignLoadingState === 'IDLE' ||
      userCampaignLoadingState === 'PENDING' ||
      jasperReportsLoadingState === 'IDLE' ||
      jasperReportsLoadingState === 'PENDING'
    ) {
      return <LoadingSpinner delay={500} />;
    }

    return (
      <ReportsList
        canDownloadReport={canDownloadReport}
        userId={userId}
        campaignId={campaignId}
        jasperReports={jasperReports}
        noReportText={noReportText}
      />
    );
  }
}

function mapStateToProps(state) {
  const userId = getUserId(state);
  const campaignId = getUserCampaignId(state);
  const userCampaignLoadingState = getUserCampaignLoadingState(state);
  const jasperReports = getReports(state);
  const jasperReportsLoadingstate = getReportsloadingState(state);
  const noReportText = getNoReportText(state);

  //FOR SOME CAMPAIGN WE WANT TO BE ABLE TO LET THE USER DOWNLOAD
  //ONE REPORT EVEN IF CAMPAIGN TESTS ARE NOT COMPLETE
  //BUT AT LEAST ONE TEST HAS TO BE COMPLETE
  //CAMPAIGN ID WHERE THIS APPLIES IS HARDCODED
  //THIS WILL BE REMOVED IN THE FUTURE
  const isDevel =
    window.location.href.includes('devel') || window.location.href.includes('localhost');
  const isProd = !isDevel;
  const hasFinishedAtLeastOneTest = state
    .getIn(['tests', 'list'])
    .some(test => test.get('status') === 'complete');

  const devCampaignIds = [1562];
  const prodCampaignIds = [1711, 1712, 1713];

  const bypassCanDownloadRepo =
    hasFinishedAtLeastOneTest &&
    ((isDevel && devCampaignIds.includes(campaignId)) ||
      (isProd && prodCampaignIds.includes(campaignId)));

  const canDownloadReport =
    getReportStatus(state) === 'COMPLETED' ||
    getReportStatus(state) === 'REPORT' ||
    bypassCanDownloadRepo;

  return {
    userId,
    campaignId,
    userCampaignLoadingState,
    noReportText,
    jasperReports,
    jasperReportsLoadingstate,
    canDownloadReport,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({push, loadUserCampaigns, loadReports}, dispatch);
}

export const ConnectedReportsPage = connect(mapStateToProps, mapDispatchToProps)(ReportsPage);
